import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "",
  isLoading: false,
  callBackRequest: false,
  isOpenModalDetail: false,
  isOpenModalEdit: false,
  isOpenModalGetLog: false,
  dataLog: [],
  idGroupNotification: "",
  isOpenModalPostGroupNotification: false,
  isOpenModalEditGroupNotification: false,
  dataGroupNotify: [],
  dataDetailGroupNotify: {},
};
const GroupNotificationSlice = createSlice({
  name: "groupNotification",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEdit = false;
      state.isOpenModalConfirm = false;
      state.isOpenModalGetLog = false;
      state.dataLog = [];
      state.idGroupNotification = "";
      state.dataDetailGroupNotify={}
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setOpenDetailGroupNotification: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idGroupNotification = action.payload.id;
    },
    setOpenModalPostGroupNotification: (state, action) => {
      state.isOpenModalPostGroupNotification = action.payload;
    },
    setOpenEditGroupNotification: (state, action) => {
      state.isOpenModalEditGroupNotification = action.payload.isOpen;
      state.idGroupNotification = action.payload.id;
    },
    setOpenModalGetLogGroupNotification: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      //add group notify
      .addCase(createGroupNotify.pending, (state) => {
        state.isLoading = true;
        state.callBackRequest = false;
      })
      .addCase(createGroupNotify.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.isLoading = false;
          state.callBackRequest = true;
          state.isNotify = true;
          state.typeNotify = "success";
          state.isOpenModalPostGroupNotification = false;
          state.msg = "Thêm thông tin thành công";
        } else {
          state.isLoading = false;
          state.callBackRequest = true;
          state.isNotify = true;
          state.isOpenModalPostGroupNotification = false;
          state.typeNotify = "error";
          state.msg = "Thêm thông tin thất bại";
        }
      })
      .addCase(createGroupNotify.rejected, (state) => {
        state.isLoading = false;
        state.callBackRequest = false;
        state.isOpenModalPostGroupNotification = false;
        state.typeNotify = "error";
        state.msg = "Thêm thông tin thất bại";
      })

      //get group notify
      .addCase(getGroupNotify.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGroupNotify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataGroupNotify = action.payload;
      })
      .addCase(getGroupNotify.rejected, (state) => {
        state.isLoading = false;
      })

      //get detail group notify
      .addCase(getDetailGroupNotify.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailGroupNotify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataDetailGroupNotify = action.payload;
      })
      .addCase(getDetailGroupNotify.rejected, (state) => {
        state.isLoading = false;
      })

      //update group notify by id
      .addCase(updateGroupNotify.pending, (state) => {
        state.isLoading = true;
        state.callBackRequest = false;
      })
      .addCase(updateGroupNotify.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.isLoading = false;
          state.callBackRequest = true;
          state.isNotify = true;
          state.isOpenModalEditGroupNotification = false;
          state.typeNotify = "success";
          state.msg = "Sửa thông tin thành công";
        } else {
          state.isLoading = false;
          state.callBackRequest = true;
          state.isNotify = true;
          state.isOpenModalEditGroupNotification = false;
          state.typeNotify = "error";
          state.msg = "Sửa thông tin thất bại";
        }
      })
      .addCase(updateGroupNotify.rejected, (state) => {
        state.isLoading = false;
        state.callBackRequest = false;
        state.typeNotify = "error";
        state.msg = "Sửa thông tin thất bại";
      })

      //delete group notify by id
      .addCase(deleteGroupNotify.pending, (state) => {
        state.isLoading = true;
        state.callBackRequest = false;
      })
      .addCase(deleteGroupNotify.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.isNotify = true;
          state.typeNotify = "success";
          state.msg = "Xóa thông tin thành công";
          state.isLoading = false;
          state.callBackRequest = true;
        } else {
          state.isNotify = true;
          state.typeNotify = "error";
          state.msg = "Xóa thông tin thất bại";
          state.isLoading = false;
          state.callBackRequest = true;
        }
      })
      .addCase(deleteGroupNotify.rejected, (state) => {
        state.isLoading = false;
        state.callBackRequest = false;
        state.typeNotify = "error";
        state.msg = "Xóa thông tin thất bại";
      })

      //get log group notify by id
      .addCase(getLogGroupNotify.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogGroupNotify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataLog = action.payload;
      })
      .addCase(getLogGroupNotify.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export default GroupNotificationSlice;

export const {
  resetStatus,
  setSearchText,
  resetState,
  setOpenDetailGroupNotification,
  setOpenModalPostGroupNotification,
  setOpenEditGroupNotification,
  setOpenModalGetLogGroupNotification,
} = GroupNotificationSlice.actions;
//Tạo văn bản thông báo nhóm
export const createGroupNotify = createAsyncThunk(
  "store/createGroupNotify",
  async (data) => {
    try {
      const res = await instance.post("/announcements", data, {});
      return res.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//Lấy danh sách thông báo nhóm
export const getGroupNotify = createAsyncThunk(
  "store/getGroupNotify",
  async ({ timeStart, timeEnd, size, page, search }) => {
    try {
      const res = await instance.get(
        `/announcements?startDate=${timeStart}&endDate=${timeEnd}&page=${page}&size=${size}&search=${search}`
      );
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//Lấy chi tiết thông báo nhóm
export const getDetailGroupNotify = createAsyncThunk(
  "store/getDetailGroupNotify",
  async (id) => {
    try {
      const res = await instance.get(`/announcements/${id}`);
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

//Update thông báo nhóm
export const updateGroupNotify = createAsyncThunk(
  "store/updateGroupNotify",
  async ({ id, formPost }) => {
    try {
      const res = await instance.put(`/announcements/${id}`, formPost);
      return res.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

//Delete thông báo nhóm
export const deleteGroupNotify = createAsyncThunk(
  "store/deleteGroupNotify",
  async (id) => {
    try {
      const res = await instance.delete(`/announcements/${id}`);
      return res;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

//Get log thông báo nhóm
export const getLogGroupNotify = createAsyncThunk(
  "store/getLogGroupNotify",
  async (id) => {
    try {
      const res = await instance.get(`/announcement-logs/announcement/${id}`);
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
